import React from "react";
import Image from "next/image";

function preprocessUrl(url) {
  if (!url) return "";
  url = url.trim();
  if (!url.includes("?") && url.includes("&")) {
    const firstAmpIndex = url.indexOf("&");
    url = url.slice(0, firstAmpIndex) + "?" + url.slice(firstAmpIndex + 1);
  }
  return url;
}

const ImageComponent = (props) => {
  const {
    src: rawSrc,
    alt,
  } = props;
  const src = preprocessUrl(rawSrc);
  const hasSizeProps = props.fill || props.width || props.height;
  const imageProps = hasSizeProps
    ? props
    : {
        ...props,
        width: 1200,
        height: 1200,
      };

  return (
    <Image
      {...imageProps}
      src={encodeURI(src)}
      alt={alt || "image"}
      // WebP previously used a native <img> fallback here. Restore only if
      // upstream WebP headers or animated WebP files break Next image handling.
      priority
    />
  );
};

export default ImageComponent;
